import * as Yup from 'yup';

import { CustodyType } from '@ndvr/portfolio-api';

export const requiredStringValidator = Yup.string().required(
    (messageParams: { label: string; path: string }) => `${getFieldName(messageParams)} is required`,
);

export const notBlankStringValidator = requiredStringValidator.test(
    'notBlank',
    (messageParams: { label: string; path: string }) => `${getFieldName(messageParams)} must not be blank`,
    (value) => value.trim().length > 0,
);

export const normalizeCustodyAccountId = (value: string): string => value.replace(/[\s-]/g, '');

export const custodyAccountIdValidator = (custodyTypeFieldName: string) => {
    return requiredStringValidator
        .transform((value: string) => (typeof value === 'string' ? normalizeCustodyAccountId(value) : value))
        .when(custodyTypeFieldName, {
            is: CustodyType.IB,
            then: (schema) => schema.matches(/^U\d{6,8}$/, 'IB account ID must start with U followed by 6-8 digits'),
        })
        .when(custodyTypeFieldName, {
            is: CustodyType.SCHWAB,
            then: (schema) => schema.matches(/^\d{8}$/, 'Schwab account ID must be 8 digits'),
        })
        .when(custodyTypeFieldName, {
            is: CustodyType.FIDELITY,
            then: (schema) =>
                schema.matches(
                    /^(?:[A-Z0-9]{7}|[A-Z0-9]{9}|[A-Z0-9]{14})$/,
                    'Fidelity account ID must be 7, 9, or 14 characters (letters and numbers)',
                ),
        });
};

const getFieldName = (messageParams: { label: string; path: string }) => {
    if (messageParams.label) {
        return messageParams.label;
    }

    if (messageParams.path) {
        const normalized = messageParams.path
            ?.replace(/([A-Z]+)/g, ' $1')
            .replace(/[[\]"]/g, '')
            .replace(/\./g, ' ')
            .toLocaleLowerCase();
        return `${normalized.charAt(0).toUpperCase()}${normalized.slice(1)}`;
    }

    return 'This field';
};
